<template>
  <div class="w1200 doc">
       <div v-for="(item,index) in lists" :key="index">
             <div class="title1">{{index+1}}.{{ item.name }}</div>
             <template v-if="item.name=='实验流程图'">
              <el-table
                :data="tableData" :span-method="arraySpanMethod"
                border
                style="width: 100%">
                      <el-table-column
                        prop="tbfont"
                        label="项目">
                         <template slot-scope="scope">
                              <div class="headdiv" v-if="scope.row.ishead"> {{scope.row.tbfont}}</div>
                              <div v-else class="tddiv2">
                                  {{scope.row.tbfont}}
                              </div>    
                         </template>
                      </el-table-column>
                      <el-table-column v-for="(it,ind) in sylct_header_list" :key="ind" align="center"
                        :prop="'biaotouid'+it.id"
                        :label="it.name">
                         <template slot-scope="scope">
                              <div class="headdiv" v-if="scope.row.ishead"></div>
                              <div v-else class="tddiv" @click="check(scope.row.itemid,scope.row['biaotouid'+it.id])">
                                   <i class="el-icon-check" v-if="ishave(scope.row.itemid,scope.row['biaotouid'+it.id])"></i> 
                                  <!-- {{scope.row.itemid}} - {{scope.row['biaotouid'+it.id]}} -->
                              </div>    
                         </template>
                      </el-table-column>
                </el-table>
              </template>
              <template v-else>
                <template v-if="item.child&&item.child.length>0">
                   <child :list="item.child" :titleindex="(index+1)"></child>
                </template>
                <template v-else>
                    <editorfull v-model="item.content"></editorfull>
                    <div class="mt_20 flex flex-v textnowap" v-if="item.ckwxtype=='2'">参考文献：<el-input placeholder="请输入参考文献" v-model="item.ckwx"></el-input></div>
                </template>  
                
              </template>
             
      </div>

        
        <div class="flex flex-v mt_30 mb_40">
          <div class="flex-1"></div>
           <el-button type="primary" class="xyb" @click="send" >导出Word</el-button>
        </div>


  </div>
</template>

<script>
import {getOrderInfo,orderEdit,orderOutWord} from "@/api/index.js"
import editorfull from  "@/components/editorfull"
import  child from "@/components/child"
export default {
  components:{editorfull,child},
  data() {
    return {
      sylct_header_list:[],
      sylct_bodylist:[],
      lists:[],
      tableData:[],
      sylctselect:[],
      ckwx:{},
      content:{},
      edit_mk_json:{}
    }
  },
   mounted() {
      getOrderInfo({id:this.$route.query.id}).then(res=>{
        if(res.code==1){
          this.sylct_header_list=res.data.sylct_header_list
          this.sylct_bodylist=res.data.sylct_bodylist;
          this.lists=res.data.lists

          let obj={}
          for(let i=0;i<this.sylct_header_list.length;i++){
            obj['biaotouid'+this.sylct_header_list[i].id]=this.sylct_header_list[i].id
          }
          for(let i=0;i<this.sylct_bodylist.length;i++){
              this.tableData.push(Object.assign({}, {
                tbfont:this.sylct_bodylist[i].name,
                itemid:this.sylct_bodylist[i].id,
                ishead:true
              }, obj))
              for(let j=0;j<this.sylct_bodylist[i].list.length;j++){
                   this.tableData.push(Object.assign({}, {
                tbfont:this.sylct_bodylist[i].list[j].name,
                itemid:this.sylct_bodylist[i].list[j].id
              }, obj))
              }
          }

          if(res.data.edit_mk_json&&res.data.edit_mk_json.sylctselect){
            this.sylctselect=res.data.edit_mk_json.sylctselect
          }
          if(res.data.edit_mk_json){
            this.edit_mk_json=res.data.edit_mk_json
            this.setuserdata(this.lists)
          }


        }
      })
    },
  methods:{
    setuserdata(lists){
        for(let i=0;i<lists.length;i++){
            if(lists[i].child&&lists[i].child.length>0){
               this.setuserdata(lists[i].child)
            }else{
               lists[i].content=this.edit_mk_json.content[lists[i].id];
               lists[i].ckwx=this.edit_mk_json.ckwx[lists[i].id];
            }
        }
    },
    ishave(itemid,biaotouid){
      let ind=this.sylctselect.findIndex(item=>item.itemid==itemid&&item.biaotouid==biaotouid)
      return ind!=-1
    },
    check(itemid,biaotouid){
      let ind=this.sylctselect.findIndex(item=>item.itemid==itemid&&item.biaotouid==biaotouid)
      if(ind!=-1){
        this.sylctselect.splice(ind,1)
      }else{
        this.sylctselect.push({"biaotouid":biaotouid,"itemid":itemid})
      }
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
        if(row.ishead){
          return [1,this.sylct_header_list.length+1]
        }
      },
      getjsonstr(list){
        for(let i=0;i<list.length;i++){
            if(list[i].child&&list[i].child.length>0){
              this.getjsonstr(list[i].child)
            }else{
              this.ckwx[list[i].id]=list[i].ckwx;
              this.content[list[i].id]=list[i].content
            }
        }
      },
    send(){
     
      this.getjsonstr(this.lists)
      
      let jsonstr={
        ckwx:this.ckwx,
        content:this.content,
        sylctselect:this.sylctselect
      }
      orderEdit({id:this.$route.query.id,jsonstr:JSON.stringify(jsonstr)}).then(res=>{
        if(res.code==1){
          this.download()
        }
      })
    },
    download(){
      orderOutWord({id:this.$route.query.id}).then(res=>{
        if(res.code==1){
          window.open(this.$imgurl(res.data.word_url),'_blank')
        }
      })
    }
  }
};
</script>

<style lang="less">
.doc {
    .xyb {background:#2397CA;font-size:20px;width:240px;height:50px;}
    .title1 {font-weight: bold;font-size:25px;margin-top:30px;margin-bottom: 10px;}
    .headdiv {font-weight: bold;background:#F4F8FC;padding:10px;}
    .el-table .el-table__cell,.el-table--border .el-table__cell:first-child .cell {padding:0px;}
    .tddiv,.has-gutter .cell,.tddiv2 {padding:10px;}
    .has-gutter .cell {text-align: center}
    .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {background:#fff;}
    .el-table__row .cell {padding:0px;}
    .tddiv {
      cursor: pointer;min-height: 43px;font-weight: bold;font-size: 22px;
    }
    .tddiv:hover {
      background:#f6f7fa
    }
}
</style>
